export default function(id) {
    return {
        open: false,
        init() {
            this.open = this.isCategoryActive();

            Alpine.$on('nav-item-opened', e => {
                e.detail !== id ? (this.open = false) : (this.open = true);
            });
        },
        toggle() {
            this.open = !this.open;
            if (this.open) Alpine.$dispatch('nav-item-opened', id);
        },
        isTopLevelActive(category) {
            const [before, topLevelCategory] = window.location.pathname.split(
                '/'
            );

            return topLevelCategory === category;
        },
        isCategoryActive() {
            const [
                before,
                topLevelCategory,
                category,
            ] = window.location.pathname.split('/');
            return category === id;
        },
        isPageActive(page) {
            return (
                window.location.pathname === page ||
                window.location.pathname === page + '/'
            );
        },
    };
}
